import client from "../../../../client";
import type { RequestConfig, ResponseErrorConfig } from "../../../../client";
import type {
  GetApiDocumentGetDocumentElectionuploadidQueryResponse,
  GetApiDocumentGetDocumentElectionuploadidPathParams,
  GetApiDocumentGetDocumentElectionuploadid401,
  GetApiDocumentGetDocumentElectionuploadid403,
} from "../../../types/GetApiDocumentGetDocumentElectionuploadid";

export function getGetApiDocumentGetDocumentElectionuploadidUrl({
  electionUploadId,
}: {
  electionUploadId: GetApiDocumentGetDocumentElectionuploadidPathParams["electionUploadId"];
}) {
  return `/api/Document/get-document/${electionUploadId}` as const;
}

/**
 * {@link /api/Document/get-document/:electionUploadId}
 */
export async function getApiDocumentGetDocumentElectionuploadid(
  {
    electionUploadId,
  }: {
    electionUploadId: GetApiDocumentGetDocumentElectionuploadidPathParams["electionUploadId"];
  },
  config: Partial<RequestConfig> & { client?: typeof client } = {}
) {
  const { client: request = client, ...requestConfig } = config;

  const res = await request<
    GetApiDocumentGetDocumentElectionuploadidQueryResponse,
    ResponseErrorConfig<
      | GetApiDocumentGetDocumentElectionuploadid401
      | GetApiDocumentGetDocumentElectionuploadid403
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiDocumentGetDocumentElectionuploadidUrl({
      electionUploadId,
    }).toString(),
    ...requestConfig,
  });
  return res;
}
